module.exports = __webpack_public_path__ + "static/img/founder2.3d475fe.png";


//////////////////
// WEBPACK FOOTER
// ./static/mt_img/founder2.png
// module id = UQi+
// module chunks = 0